import { render, staticRenderFns } from "./LanguageExport.vue?vue&type=template&id=36d4a8b0&"
import script from "./LanguageExport.vue?vue&type=script&lang=js&"
export * from "./LanguageExport.vue?vue&type=script&lang=js&"
import style0 from "./LanguageExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports